import { useTranslation } from 'react-i18next';
import { Typography, Card, CardContent, Box, IconButton } from '@mui/material';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { GridColDef } from '@mui/x-data-grid';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import dayjs from 'dayjs';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useGetHealthListQuery } from '@/api/app-setting/healthApiSlice';
import LocalDataGrid from '@/common/components/dataGrid/LocalDataGrid';
import { HealthAssessmentResultDTO } from '@/api/DTO/app-setting/health.interface';

export interface DataGrid {
	updatedAt: string;
	createdAt: string;
}

export default function HealthListSummaryPage() {
	const { t } = useTranslation();

	const { data: propertySummary, isSuccess: isGetPropertySummarySuccess } =
		useGetHealthListQuery(null, {
			refetchOnMountOrArgChange: true,
		});

	console.log(propertySummary);

	const transformResponse = useCallback(
		(response?: HealthAssessmentResultDTO[]) => {
			if (response == null) return;
			const newResponse: DataGrid[] = [];
			response.forEach((item) => {
				newResponse.push({
					...item,
					createdAt: !item.createdAt
						? '-'
						: dayjs(item.createdAt)
								.locale('en')
								.format(DISPLAY_DATETIME_12H_FORMAT),
					updatedAt: !item.updatedAt
						? '-'
						: dayjs(item.updatedAt)
								.locale('en')
								.format(DISPLAY_DATETIME_12H_FORMAT),
				});
			});
			return newResponse;
		},
		[]
	);

	const columns: GridColDef[] = [
		{
			field: 'typeLabel',
			headerName: t('health.resultType'),
			flex: 21,
		},
		{
			field: 'updatedAt',
			headerName: t('health.lastUpdateTime'),
			flex: 21,
		},
		{
			field: 'edit',
			headerName: '',
			width: 68,
			renderCell: (params) => (
				<Link to={`/app-setting/health-list/info/${params.id}`}>
					<IconButton color='primary'>
						<VisibilityOutlinedIcon />
					</IconButton>
				</Link>
			),
		},
	];

	return (
		<>
			<Box display='flex' justifyContent='space-between'>
				<Typography variant='h4'>{t('drawerListItems.healthList')}</Typography>
			</Box>

			<Card sx={{ marginTop: 3 }}>
				<CardContent>
					<Box marginTop={2}>
						<LocalDataGrid
							rows={transformResponse(propertySummary?.data) ?? []}
							columns={columns}
							rowCount={0}
							getRowId={(row) => row.id}
							pagination={false}
						/>
					</Box>
				</CardContent>
			</Card>
		</>
	);
}
